import MuiMobileStepper, {
  type MobileStepperProps,
} from "@mui/material/MobileStepper";

export type { MobileStepperProps };

export function MobileStepper(props: MobileStepperProps) {
  return <MuiMobileStepper {...props} />;
}
